export default __webpack_public_path__ + "media/images/icons_fc/star-c7c8bc79fd02cb9a5f80d33ae4d6f046.png";